export default "__VITE_ASSET___k09QUPS__"